import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import {
  ExclamationCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/20/solid";
import { Dialog } from "@headlessui/react";


function UpdateConfirmation({ id_crypt, apiType, fetchClientData, inputs, dialogClose }) {

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const openDialog = (id_crypt) => {
    setCurrentProjectId(id_crypt);
    setIsDialogOpen(true);
  };

  const handleUpdateForLeadTask = async (e) => {
    e.preventDefault();
    let endpoint = "";

    if (apiType === "task") {
      endpoint = `public/api/admin/client_project_task/update/${currentProjectId}`;
    } else if (apiType === "project") {
      endpoint = `public/api/admin/client_project/update/${currentProjectId}`;
    } else if (apiType === "product") {
      endpoint = `public/api/admin/product/update/${currentProjectId}`;
    } else if (apiType === "vendor") {
      endpoint = `public/api/admin/vendor/update/${currentProjectId}`;
    } else if (apiType === "sales") {
      endpoint = `public/api/admin/clientsales/update/${currentProjectId}`;
    } else if (apiType === "purchase") {
      endpoint = `public/api/admin/purchase/update/${currentProjectId}`;
    } else if (apiType === "device") {
      endpoint = `public/api/admin/device/update/${currentProjectId}`;
    } else if (apiType === "dealer") {
      endpoint = `public/api/admin/dealer/update/${currentProjectId}`;
    } else if (apiType === "customer") {
      endpoint = `public/api/admin/customer/update/${currentProjectId}`;
    } else if (apiType === "payment") {
      endpoint = `public/api/admin/payment_mode/update/${currentProjectId}`;
    } else if (apiType === "bill_type") {
      endpoint = `public/api/admin/bill_type/update/${currentProjectId}`;
    } else if (apiType === "product_type") {
      endpoint = `public/api/admin/product_type/update/${currentProjectId}`;
    } else if (apiType === "code_type") {
      endpoint = `public/api/admin/code_type/update/${currentProjectId}`;
    } else if (apiType === "lead") {
      endpoint = `public/api/admin/lead/update/${currentProjectId}`;
    } else if (apiType === "leadSource") {
      endpoint = `public/api/admin/leadsource/update/${currentProjectId}`;
    } else if (apiType === "leadStatus") {
      endpoint = `public/api/admin/leadstatus/update/${currentProjectId}`;
    } else if (apiType === "lead_task") {
      endpoint = `public/api/admin/tasks/update/${currentProjectId}`;
    } else if (apiType === "quotation") {
      endpoint = `public/api/admin/quotation/update/${currentProjectId}`;
    } else if (apiType === "employee") {
      endpoint = `public/api/admin/employees/update/${currentProjectId}`;
    } else if (apiType === "role") {
      endpoint = `public/api/admin/leadrole/update/${currentProjectId}`;
    } else if (apiType === "roleassign") {
      endpoint = `public/api/admin/leadroleassign/update/${currentProjectId}`;
    } else if (apiType === "taskDiscussionStatus") {
      endpoint = `public/api/admin/taskdiscussionstatus/update/${currentProjectId}`;
    } else if (apiType === "branch") {
      endpoint = `public/api/admin/branch/update/${currentProjectId}`;
    }

    try {
      const response = await axios.put(endpoint, inputs, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      toast.success(response.data.message);

      if (typeof fetchClientData === "function") {
        await fetchClientData();
        setIsDialogOpen(false);
        dialogClose(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update item.");
    }
  };

  // const closeDialog = () => {
  //   setIsDialogOpen(false);
  //   setCurrentProjectId(null);
  // };

  return (
    <div>
      {/* Update Button */}
      <div className="relative inline-block">
        <button
          type="button"
          className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => openDialog(id_crypt)}
        >
          {/* <PencilSquareIcon className="h-5 w-5 text-white" /> */}
          Update
          <Tooltip
            anchorSelect=".my-anchor-update"
            place="top"
            className="text-xs"
            style={{ fontSize: "12px", padding: "0.3rem" }}
          >
            Update
          </Tooltip>
        </button>
      </div>

      {/* {isDialogOpen && (
  <div className="fixed inset-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
        <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
          <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
            <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
          </span>
          <div className="text-center sm:text-left mt-3 sm:mt-0">
            <h2 className="text-lg font-bold text-gray-800">
              Update Confirmation
            </h2>
            <p className="text-gray-600">
              Are you sure you want to update this item?
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
        <button
          className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={(e) => handleUpdateForLeadTask(e)}
          className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Update
        </button>
      </div>
    </div>
  </div>
)} */}


<Dialog open={isDialogOpen}
 onClose={()=>{}} 
 className="relative z-50">
      {/* Background Overlay */}
      <div className="fixed inset-0 bg-gray-800 bg-opacity-75" aria-hidden="true" />

      {/* Dialog Content */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
          <Dialog.Title className="text-lg font-bold text-gray-800">
            Update Confirmation
          </Dialog.Title>

          <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
            <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
              <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
                <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
              </span>
              <div className="text-center sm:text-left mt-3 sm:mt-0">
                <p className="text-gray-600">
                  Are you sure you want to update this item?
                </p>
              </div>
            </div>
          </div>

          {/* Button Controls */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
            <button
              onClick={()=>setIsDialogOpen(false)}
              className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={(e) => handleUpdateForLeadTask(e)}
              className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Update
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>

    </div>
  );
}

export default UpdateConfirmation;
